import React, { useState } from 'react';
import ModalInput from '../Modals/ModalInput';
import { updatePrecheck } from '../../services/APIs';

interface ReportDetailTextProps {
    valueName?: string;
    title: React.ReactElement | string;
    id?: string;
    value: string;
    isEditable?: boolean;
    isEditing?: boolean;
    name: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onDiscard?: (name: any) => void;
    handleConfirm?: () => Promise<void>;
    updateDriver?: (id: any, data: any) => void;
}

const ReportDetailText = (props: ReportDetailTextProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [inputValue, setInputValue] = useState(props.value);

    const handleEdit = () => {
        setIsEditing(true);
        setOpenModal(true);
        setInputValue(props.value);
    };

    const handleConfirm = async () => {
        if (inputValue.trim() !== '') {
            setIsEditing(false);
            setOpenModal(false);
            if (props.id) {
                await updatePrecheck(props.id, {[props.name]: inputValue}, "en");
            }
            // if (props.updateDriver) {
            //     const payload = { [props.name]: inputValue };
            //     await props.updateDriver(props.id, payload);
            // }
            // Update the props.value
            props.onChange?.({ target: { name: props.name, value: inputValue } } as React.ChangeEvent<HTMLInputElement>);
        }
    };

    const handleDiscard = () => {
        setIsEditing(false);
        setOpenModal(false);
        setInputValue(props.value);
        if (props.onDiscard) {
            props.onDiscard(props.name);
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
    };

    const trailerSizeList = ['46', '48', '53', '57'];

    return (
        <>
            <li>
                <label>
                    {props.title}
                    {props.isEditable && !isEditing && (
                        <span onClick={handleEdit}><img src='/edit-icon.png' alt="Edit" /></span>
                    )}
                </label>
                {!isEditing && props.value && props.value.length > 0 && !(props.value === 'N/A') && <p>{props.value}</p>}
            </li>
            {isEditing && (
                <ModalInput
                    open={openModal}
                    title={props.valueName as string}
                    subtitle={`Please confirm ${props.valueName} below`}
                    buttonOneText="Confirm"
                    buttonOneAction={handleConfirm}
                    buttonTwoText="Discard"
                    buttonTwoAction={handleDiscard}
                    handleClose={() => setOpenModal(false)}
                    twoButtons={true}
                >
                    <div className="form-subtitle mx-2 flex justify-content-center">
                        {props.name === "submittedTrailerLength" ? (
                            <div className="check-box-wrapper d-flex justify-content-center">
                                {trailerSizeList.map((trailerSize: string) => (
                                    <div className="form-check" key={trailerSize}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="submittedTrailerLength"
                                            id={`size-${trailerSize}`}
                                            hidden
                                            checked={String(trailerSize) === inputValue}
                                            onChange={(e) => setInputValue(e.target.value)}
                                            value={trailerSize}
                                        />
                                        <label className="form-check-label" htmlFor={`size-${trailerSize}`}>
                                            {trailerSize}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <input
                                type="text"
                                name={props.name}
                                value={inputValue}
                                onChange={handleInputChange}
                            />
                        )}
                    </div>
                </ModalInput>
            )}
        </>
    );
};

export default ReportDetailText;
